import { useSelector } from "react-redux";
import { selectToken } from "../store/auth/index";

export const useAuth = () => {
  const token = useSelector(selectToken);
  return token;
};
